module.exports = __webpack_public_path__ + "static/media/img.c15c00db.png";